(() => {
  let overlay;
  // Don't open overlay in old Frontend
  if (document.documentElement.classList.contains('js')) {
    return;
  }
  const openOverlay = () => new Promise((resolve) => {
    overlay = window.swinger.widgets[overlay ? 'replace' : 'create']({
      type: 'in-place-registration',
    }, overlay);

    (
      document.getElementById('swinger-append-container')
      || window.swinger.$('body', document)[0]
    ).appendChild(overlay);

    const callback = (e) => {
      const elem = e.detail.elem;

      if (elem && elem.matches('.swinger-overlay-in-place-registration')) {
        window.swinger.eventHub.trigger(document, 'swinger-data-popover:close');

        document.removeEventListener('swinger.overlay:open', callback);
        resolve();
      }
    };

    document.addEventListener('swinger.overlay:open', callback);
  });

  window.swinger.eventHub.register('click', `[href="${window.swinger.config.pages.register}"]`, (e) => {
    const elem = window.swinger.eventHub.getTarget(e).closest('a');

    window.swinger.transition.tag(elem, 'swinger-in-place-registration');

    window.swinger.$(`[href="${window.swinger.config.pages.register}"]`).forEach((elem) => { elem.removeAttribute('data-invoker'); });
    elem.setAttribute('data-invoker', '');

    const loginOverlay = document.getElementById('swinger-overlay-in-place-registration');
    if (loginOverlay) {
      window.swinger.overlayManager.close(loginOverlay);
    }

    openOverlay();

    e.preventDefault();
  });

  window.swinger.observer.initialize(`[href="${window.swinger.config.pages.register}"]`, (elem) => {
    elem.setAttribute('role', 'button');
    elem.setAttribute('aria-controls', 'swinger-overlay-in-place-registration');
    elem.setAttribute('aria-expanded', 'false');
    elem.setAttribute('aria-haspopup', 'dialog');
  }, false);
})();
